import {
  KITS_BYPATIENT_GET_LIST,
  KITS_BYPATIENT_GET_LIST_SUCCESS,
  KITS_BYPATIENT_GET_LIST_ERROR,
  KITS_USER_GET_LIST,
  KITS_USER_GET_LIST_SUCCESS,
  KITS_USER_GET_LIST_ERROR,
  KITS_BYDOCTOR_GET_LIST,
  KITS_BYDOCTOR_GET_LIST_SUCCESS,
  KITS_BYDOCTOR_GET_LIST_ERROR,
  KIT_GET_INFO,
  KIT_GET_INFO_SUCCESS,
  KIT_GET_INFO_ERROR,
  KIT_ADD_ITEM,
  KIT_ADD_ITEM_SUCCESS,
  KIT_ADD_ITEM_ERROR,
  KIT_EDIT_ITEM,
  KIT_EDIT_ITEM_SUCCESS,
  KIT_EDIT_ITEM_ERROR,
  KIT_UNLOCK_PLUGIN_ITEM,
  KIT_UNLOCK_PLUGIN_ITEM_SUCCESS,
  KIT_UNLOCK_PLUGIN_ITEM_ERROR,
  KIT_ACTIVATE_ITEM,
  KIT_ACTIVATE_ITEM_SUCCESS,
  KIT_ACTIVATE_ITEM_ERROR,
  KIT_GET_RESULTS,
  KIT_GET_RESULTS_SUCCESS,
  KIT_GET_RESULTS_ERROR,
  KIT_GET_RESULTS_BEHAVIOUR,
  KIT_GET_RESULTS_BEHAVIOUR_SUCCESS,
  KIT_GET_RESULTS_BEHAVIOUR_ERROR,
  KIT_GET_RESULTS_BIOMARKERS,
  KIT_GET_RESULTS_BIOMARKERS_SUCCESS,
  KIT_GET_RESULTS_BIOMARKERS_ERROR,
  KITS_GET_RESULTS_TIMECOURSE,
  KITS_GET_RESULTS_TIMECOURSE_SUCCESS,
  KITS_GET_RESULTS_TIMECOURSE_ERROR,
  KIT_REMOVE_ITEM,
  KIT_REMOVE_ITEM_SUCCESS,
  KIT_REMOVE_ITEM_ERROR,
  KIT_GET_UPLOADED_DATA,
  KIT_GET_UPLOADED_DATA_SUCCESS,
  KIT_GET_UPLOADED_DATA_ERROR,
  KIT_REMOVE_UPLOADED_DATA,
  KIT_REMOVE_UPLOADED_DATA_SUCCESS,
  KIT_REMOVE_UPLOADED_DATA_ERROR,
  KIT_TAKEACTION_EDIT_ITEM,
  KIT_TAKEACTION_EDIT_ITEM_SUCCESS,
  KIT_TAKEACTION_EDIT_ITEM_ERROR,
  KIT_RESULTS_COMMENTS_EDIT_ITEM,
  KIT_RESULTS_COMMENTS_EDIT_ITEM_SUCCESS,
  KIT_RESULTS_COMMENTS_EDIT_ITEM_ERROR,
  KIT_TAKEACTION_REMOVE_ITEM,
  KIT_TAKEACTION_REMOVE_ITEM_SUCCESS,
  KIT_TAKEACTION_REMOVE_ITEM_ERROR,
  KIT_REPORT_GET_LOGO,
  KIT_REPORT_GET_LOGO_SUCCESS,
  KIT_REPORT_GET_LOGO_ERROR,
  KIT_REPORT_EDIT_LOGO,
  KIT_REPORT_EDIT_LOGO_SUCCESS,
  KIT_REPORT_EDIT_LOGO_ERROR,
  KIT_CLEAR_DATA,
  KITS_BYPATIENT_LIST_CLEAR_DATA,
  KITS_RESULTS_CLEAR_DATA,
  KIT_CLEAR_MESSAGES,
  KITS_RESULTS_TIMECOURSE_CLEAR_DATA,
} from '../actions';

const INIT_STATE = {
  loading: false,
  loadingKitsPatientList: false,
  loadingKitsDoctorList: false,
  loadingKitInfo: false,
  loadingKitAddItem: false,
  loadingKitEditItem: false,
  loadingUnlockPluginItem: false,
  loadingKitActivateItem: false,
  loadingKitResults: false,
  loadingKitResultsBehaviour: false,
  loadingKitResultsBiomarkers: false,
  loadingKitsResultsTimecourse: false,
  loadingKitRemoveItem: false,
  loadingKitUploadedData: false,
  loadingUploadedDataRemoveItem: false,
  loadingKitResultsTakeActionEditItem: false,
  loadingKitResultsCommentsEditItem: false,
  loadingKitResultsTakeActionRemoveItem: false,
  kitsPatientList: null, //was []
  listByUser: null,
  listByDoctor: null,
  kitInfo: null,
  kitAddItem: null,
  kitEditItem: null,
  kitUnlockPluginItem: null,
  kitActivateItem: null,
  kitResults: null,
  kitResultsBehaviour: null,
  kitResultsBiomarkers: null,
  kitsResultsTimecourse: null,
  kitRemoveItem: null,
  kitUploadedData: null,
  kitReportLogo: null,
  kitEditReportLogo: null,
  kitRemoveUploadedData: null,
  kitResultsTakeActionEditItem: null,
  kitResultsCommentsEditItem: null,
  kitResultsTakeActionRemoveItem: null,
  error: '',
  storedErrors: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //* GET LIST KITS PER PATIENT // ---------------------------------------------------------------------------------------------

    case KITS_BYPATIENT_GET_LIST:
      return { ...state, loadingKitsPatientList: true, error: '' };

    case KITS_BYPATIENT_GET_LIST_SUCCESS:
      //console.log(action.payload);

      return {
        ...state,
        loadingKitsPatientList: false,
        kitsPatientList: action.payload,
        error: '',
      };

    case KITS_BYPATIENT_GET_LIST_ERROR:
      return { ...state, loadingKitsPatientList: false, error: action.payload };

    //* GET LIST KITS PER USER // ---------------------------------------------------------------------------------------------

    case KITS_USER_GET_LIST:
      return { ...state, loadingKitsDoctorList: true, error: '' };

    case KITS_USER_GET_LIST_SUCCESS:
      // console.log("success", action.payload);

      return {
        ...state,
        loadingKitsDoctorList: false,
        listByUser: action.payload,
        error: '',
      };

    case KITS_USER_GET_LIST_ERROR:
      //console.log("error", action.payload);
      return { ...state, loadingKitsDoctorList: false, error: action.payload };

    //* GET LIST KITS PER DOCTOR // ---------------------------------------------------------------------------------------------

    case KITS_BYDOCTOR_GET_LIST:
      return { ...state, loading: true, error: '' };

    case KITS_BYDOCTOR_GET_LIST_SUCCESS:
      //console.log("success", action.payload);

      return {
        ...state,
        loading: false,
        listByDoctor: action.payload,
        error: '',
      };

    case KITS_BYDOCTOR_GET_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };

    //* ADD KIT // ---------------------------------------------------------------------------------------------

    case KIT_ADD_ITEM:
      return { ...state, loadingKitAddItem: true, error: '' };

    case KIT_ADD_ITEM_SUCCESS:
      console.log('success', action.payload);
      return {
        ...state,
        loadingKitAddItem: false,
        kitAddItem: action.payload,
        error: '',
      };

    case KIT_ADD_ITEM_ERROR:
      return {
        ...state,
        loadingKitAddItem: false,
        kitAddItem: null,
        error: Array.isArray(action.payload)
          ? action.payload.error
          : action.payload,
        storedErrors: [...state.storedErrors, action.payload],
      };

    //* GET INFO SINGLE KIT // ---------------------------------------------------------------------------------------------
    case KIT_GET_INFO:
      return { ...state, loadingKitInfo: true, error: '' };

    case KIT_GET_INFO_SUCCESS:
      console.log('success', action.payload);
      return {
        ...state,
        loadingKitInfo: false,
        kitInfo: action.payload,
        error: '',
      };

    case KIT_GET_INFO_ERROR:
      return { ...state, loadingKitInfo: false, error: action.payload };

    //* EDIT KIT // ---------------------------------------------------------------------------------------------

    case KIT_EDIT_ITEM:
      return { ...state, loadingKitEditItem: true, error: '' };

    case KIT_EDIT_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loadingKitEditItem: false,
        kitEditItem: action.payload,
        error: '',
      };

    case KIT_EDIT_ITEM_ERROR:
      return {
        ...state,
        loadingKitEditItem: false,
        kitEditItem: null,
        error: action.payload,
      };

    //* UNLOCK PLUGIN // ---------------------------------------------------------------------------------------------

    case KIT_UNLOCK_PLUGIN_ITEM:
      return { ...state, loadingUnlockPluginItem: true, error: '' };

    case KIT_UNLOCK_PLUGIN_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loadingUnlockPluginItem: false,
        kitUnlockPluginItem: action.payload,
        error: '',
      };

    case KIT_UNLOCK_PLUGIN_ITEM_ERROR:
      return {
        ...state,
        loadingUnlockPluginItem: false,
        kitUnlockPluginItem: null,
        error: action.payload,
      };

    //* ACTIVATE KIT // ---------------------------------------------------------------------------------------------

    case KIT_ACTIVATE_ITEM:
      return { ...state, loadingKitActivateItem: true, error: '' };

    case KIT_ACTIVATE_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loadingKitActivateItem: false,
        kitActivateItem: action.payload,
        error: '',
      };

    case KIT_ACTIVATE_ITEM_ERROR:
      return {
        ...state,
        loadingKitActivateItem: false,
        kitActivateItem: null,
        error: action.payload,
      };

    //* GET RESULTS SINGLE KIT // ---------------------------------------------------------------------------------------------
    case KIT_GET_RESULTS:
      return { ...state, loadingKitResults: true, error: '' };

    case KIT_GET_RESULTS_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loadingKitResults: false,
        kitResults: action.payload,
        error: '',
      };

    case KIT_GET_RESULTS_ERROR:
      return { ...state, loadingKitResults: false, error: action.payload };

    //* GET BEHAVIOUR for RESULTS  // ---------------------------------------------------------------------------------------------
    case KIT_GET_RESULTS_BEHAVIOUR:
      return { ...state, loadingKitResultsBehaviour: true, error: '' };

    case KIT_GET_RESULTS_BEHAVIOUR_SUCCESS:
      // console.log("success", action.payload);
      return {
        ...state,
        loadingKitResultsBehaviour: false,
        kitResultsBehaviour: action.payload,
        error: '',
      };

    case KIT_GET_RESULTS_BEHAVIOUR_ERROR:
      return {
        ...state,
        loadingKitResultsBehaviour: false,
        error: action.payload,
      };

    //* GET BIOMARKERS for RESULTS  // ---------------------------------------------------------------------------------------------
    case KIT_GET_RESULTS_BIOMARKERS:
      return { ...state, loadingKitResultsBiomarkers: true, error: '' };

    case KIT_GET_RESULTS_BIOMARKERS_SUCCESS:
      //  console.log("success", action.payload);
      return {
        ...state,
        loadingKitResultsBiomarkers: false,
        kitResultsBiomarkers: action.payload,
        error: '',
      };

    case KIT_GET_RESULTS_BIOMARKERS_ERROR:
      return {
        ...state,
        loadingKitResultsBiomarkers: false,
        error: action.payload,
      };

    //* GET TIMECOURSE for RESULTS  // ---------------------------------------------------------------------------------------------
    case KITS_GET_RESULTS_TIMECOURSE:
      return { ...state, loadingKitsResultsTimecourse: true, error: '' };

    case KITS_GET_RESULTS_TIMECOURSE_SUCCESS:
      console.log('success', action);
      return {
        ...state,
        loadingKitsResultsTimecourse: false,

        kitsResultsTimecourse: {
          ...state.kitsResultsTimecourse,
          [action.payload.target]: action.payload.response,
        },
        error: '',
      };

    case KITS_GET_RESULTS_TIMECOURSE_ERROR:
      return {
        ...state,
        loadingKitsResultsTimecourse: false,
        error: action.payload,
      };

    //* REMOVE KIT // ---------------------------------------------------------------------------------------------
    case KIT_REMOVE_ITEM:
      return { ...state, loadingKitRemoveItem: true, error: '' };

    case KIT_REMOVE_ITEM_SUCCESS:
      console.log('KIT_REMOVE_ITEM_SUCCESS', action.payload);
      return {
        ...state,
        loadingKitRemoveItem: false,
        kitRemoveItem: action.payload,
        error: '',
      };

    case KIT_REMOVE_ITEM_ERROR:
      return {
        ...state,
        loadingKitRemoveItem: false,
        kitRemoveItem: null,
        error: action.payload,
      };

    //* GET UPLOADED DATA SINGLE KIT // ---------------------------------------------------------------------------------------------
    case KIT_GET_UPLOADED_DATA:
      return { ...state, loadingKitUploadedData: true, error: '' };

    case KIT_GET_UPLOADED_DATA_SUCCESS:
      // console.log("success", action.payload);
      // console.log("state", state, state.kitUploadedData);
      return {
        ...state,
        loadingKitUploadedData: false,
        kitUploadedData: {
          ...state.kitUploadedData,
          // [action.payload[0]._id]: action.payload[0],
          [action.payload[0].experimentId]: [...action.payload],
        },
        error: '',
      };

    case KIT_GET_UPLOADED_DATA_ERROR:
      return {
        ...state,
        loadingKitUploadedData: false,
        //kitUploadedData: null,
        //error: action.payload,
      };

    //* DELETE UPLOADED DATA SINGLE KIT // ---------------------------------------------------------------------------------------------

    case KIT_REMOVE_UPLOADED_DATA:
      return { ...state, loadingUploadedDataRemoveItem: true, error: '' };

    case KIT_REMOVE_UPLOADED_DATA_SUCCESS:
      console.log('success', action.payload);
      console.log('state', state, state.kitUploadedData);
      return {
        ...state,
        loadingUploadedDataRemoveItem: false,
        kitRemoveUploadedData: action.payload,
        error: '',
      };

    case KIT_REMOVE_UPLOADED_DATA_ERROR:
      return {
        ...state,
        loadingUploadedDataRemoveItem: false,
        kitRemoveUploadedData: null,
        error: action.payload,
      };

    //* EDIT KIT RESULTS TAKE ACTION // ---------------------------------------------------------------------------------------------

    case KIT_TAKEACTION_EDIT_ITEM:
      return { ...state, loadingKitResultsTakeActionEditItem: true, error: '' };

    case KIT_TAKEACTION_EDIT_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loadingKitResultsTakeActionEditItem: false,
        kitResultsTakeActionEditItem: action.payload,
        error: '',
      };

    case KIT_TAKEACTION_EDIT_ITEM_ERROR:
      return {
        ...state,
        loadingKitResultsTakeActionEditItem: false,
        kitResultsTakeActionEditItem: null,
        error: action.payload,
      };

    //* EDIT KIT RESULTS COMMENTS // ---------------------------------------------------------------------------------------------

    case KIT_RESULTS_COMMENTS_EDIT_ITEM:
      return { ...state, loadingKitResultsCommentsEditItem: true, error: '' };

    case KIT_RESULTS_COMMENTS_EDIT_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loadingKitResultsCommentsEditItem: false,
        kitResultsCommentsEditItem: action.payload,
        error: '',
      };

    case KIT_RESULTS_COMMENTS_EDIT_ITEM_ERROR:
      return {
        ...state,
        loadingKitResultsCommentsEditItem: false,
        kitResultsCommentsEditItem: null,
        error: action.payload,
      };

    //* REMOVE KIT RESULTS EDITED TAKE ACTION // ---------------------------------------------------------------------------------------------

    case KIT_TAKEACTION_REMOVE_ITEM:
      return {
        ...state,
        loadingKitResultsTakeActionRemoveItem: true,
        error: '',
      };

    case KIT_TAKEACTION_REMOVE_ITEM_SUCCESS:
      console.log('KIT_REMOVE_ITEM_SUCCESS', action.payload);
      return {
        ...state,
        loadingKitResultsTakeActionRemoveItem: false,
        kitResultsTakeActionRemoveItem: action.payload,
        error: '',
      };

    case KIT_TAKEACTION_REMOVE_ITEM_ERROR:
      return {
        ...state,
        loadingKitResultsTakeActionRemoveItem: false,
        kitResultsTakeActionRemoveItem: null,
        error: action.payload,
      };

    //* GET REPORT LOGO  ---------------------------------------------------------------------------
    case KIT_REPORT_GET_LOGO:
      console.log('inside reducer get report logo');
      return { ...state, loading: true, error: '' };

    case KIT_REPORT_GET_LOGO_SUCCESS:
      console.log('logo get success', action.payload);
      return {
        ...state,
        loading: false,
        kitReportLogo: action.payload,
        error: '',
      };

    case KIT_REPORT_GET_LOGO_ERROR:
      return {
        ...state,
        loading: false,
        // kitReportLogo: "",
        error: action.payload,
      };

    //* EDIT KIT REPORT LOGO   -----------------------------------------------------------------------------

    case KIT_REPORT_EDIT_LOGO:
      // console.log("inside reducer add avatar");
      return { ...state, loading: true, error: '' };

    case KIT_REPORT_EDIT_LOGO_SUCCESS:
      // console.log("avatar add success", action.payload);
      return {
        ...state,
        loading: false,
        kitEditReportLogo: action.payload,
        error: '',
      };

    case KIT_REPORT_EDIT_LOGO_ERROR:
      return {
        ...state,
        loading: false,
        kitEditReportLogo: null,
        error: action.payload,
      };

    //* CLEAR KIT DATA // ---------------------------------------------------------------------------------------------

    case KIT_CLEAR_DATA:
      return {
        ...INIT_STATE,
      };

    //* CLEAR KITS LIST DATA of the PATIENT // ---------------------------------------------------------------------------------------------

    case KITS_BYPATIENT_LIST_CLEAR_DATA:
      return {
        ...state,
        kitsPatientList: null,
      };

    //* CLEAR KIT RESULT DATA of the PATIENT // ---------------------------------------------------------------------------------------------

    case KITS_RESULTS_CLEAR_DATA:
      return {
        ...state,
        kitResults: null,
      };

    //* CLEAR KITS RESULTS TIMECOURSE DATA of the PATIENT // ---------------------------------------------------------------------------------------------

    case KITS_RESULTS_TIMECOURSE_CLEAR_DATA:
      return {
        ...state,
        kitsResultsTimecourse: null,
      };

    //* CLEAR MESSAGES // ---------------------------------------------------------------------------------------------

    case KIT_CLEAR_MESSAGES:
      return {
        ...state, // repeat all the state and apply the following changes

        addItem: null,
        editItem: null,
        removeItem: null,
        error: '',
        storedErrors: [],
      };

    default:
      return { ...state };
  }
};
